import { RefObject, useRef, useState } from 'react';

import { Icon } from '@iconify/react';

import MediaMethods from '../mediaDataCollector/MediaMethods';

interface PlayButtonProps {
  playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>;
  progressBarRef: RefObject<HTMLInputElement>;
  updateProgressBarAndPlayerCurrentTime: () => Promise<void>;
  onClickPlay?: () => void;
}

function PlayButton({
  playerRef,
  progressBarRef,
  updateProgressBarAndPlayerCurrentTime,
  onClickPlay,
}: PlayButtonProps) {
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const animationRef = useRef<number>(0);

  async function updateProgressBarFromMediaCurrentTime() {
    progressBarRef.current!.value = (await MediaMethods.getCurrentTime(playerRef)).toString();

    updateProgressBarAndPlayerCurrentTime();
    animationRef.current = requestAnimationFrame(updateProgressBarFromMediaCurrentTime);
  }

  function handlePlayButton() {
    setIsPlaying(!isPlaying);
    if (!isPlaying) {
      MediaMethods.play(playerRef);
      onClickPlay?.();
      animationRef.current = requestAnimationFrame(updateProgressBarFromMediaCurrentTime);
    } else {
      MediaMethods.pause(playerRef);

      cancelAnimationFrame(animationRef.current);
    }
  }

  return (
    <button className="media-player-button" onClick={handlePlayButton} type="button">
      <Icon
        className="media-player-icon"
        icon={`material-symbols:${isPlaying ? 'pause' : 'play-arrow'}`}
        height="1.25rem"
        width="1.25rem"
      />
    </button>
  );
}

export default PlayButton;
